import React, {useEffect, useState} from "react";
import {config} from "../../../config";
import {useHistory, useLocation} from "react-router-dom";
import {RouteDefine} from "../../../routes/RouteDefine";
import {QHelpers} from "../../../common/helpers";
import QModal from "../../../common/components/QModal";
import webhookEconomicForm from "../../../assets/images/logo/2app-stripe-big-logo.png";
import BodyModalSubscriptionTermsComponent from "./BodyModalSubscriptionTermsComponent";
import BodyStripeConnectComponent from "../../private/Stripe/components/BodyStripeConnectComponent";
import {buildStripeOAuthUrl, getStripeAccessToken} from "../../../common/helpers/stripeOAuth";
import {resolveOnboardingStep, isAdminAccount} from "../../../common/helpers/onboardingResume";
import {refreshAccountSetup} from "../../../common/helpers/refreshAccountSetup";
import {useTranslation} from "react-i18next";


interface LocationState {
    agreementNumber?: string | number;
    user?: { name?: string };
    company?: { name?: string };
}

export function Confirm() {
    const history = useHistory();
    const location = useLocation<LocationState | undefined>();
    const {t} = useTranslation();
    const response = location.state;

    const [openModal, setOpenModal] = useState(false);
    const [openManualToken, setOpenManualToken] = useState(false);
    const [manualLoading, setManualLoading] = useState(false);
    let localItemInfo: any = QHelpers.store.localStorageGetItem(config.LOCAL_STORE.ACCOUNT);
    try {
        localItemInfo = JSON.parse(localItemInfo);
    } catch (err) {
        localItemInfo = {};
    }

    const step = resolveOnboardingStep(localItemInfo);
    const accessToken = localItemInfo?.access_token || getStripeAccessToken();
    const displayName =
        response?.user?.name
        || response?.company?.name
        || localItemInfo?.user?.name
        || localItemInfo?.user?.company_name
        || "";
    const agreementNumber =
        response?.agreementNumber
        || localItemInfo?.agreementNumber
        || localItemInfo?.user?.account_number
        || "";

    const [ready, setReady] = useState(false);
    const [liveStep, setLiveStep] = useState(step);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (!accessToken) {
                history.replace(RouteDefine.login);
                return;
            }
            if (isAdminAccount(localItemInfo)) {
                history.replace(RouteDefine.admin);
                return;
            }
            const account = await refreshAccountSetup();
            if (cancelled) return;
            const nextStep = resolveOnboardingStep(account || localItemInfo);
            setLiveStep(nextStep);
            if (nextStep === 2) {
                history.replace(RouteDefine.setup);
                return;
            }
            if (nextStep === -1) {
                history.replace(RouteDefine.dashboard);
                return;
            }
            setReady(true);
        })();
        return () => { cancelled = true; };
    }, [accessToken, history]);

    const stripeUrl = accessToken
        ? buildStripeOAuthUrl(accessToken, 'setup')
        : '';

    const handleManualStripeSuccess = async () => {
        setManualLoading(true);
        try {
            const account = await refreshAccountSetup();
            const nextStep = resolveOnboardingStep(account || localItemInfo);
            if (nextStep === 2) {
                history.replace(RouteDefine.setup);
                return;
            }
            if (nextStep === -1) {
                history.replace(RouteDefine.dashboard);
                return;
            }
            setLiveStep(nextStep);
            setReady(true);
        } finally {
            setManualLoading(false);
        }
    };

    return (
        <React.Fragment>
            <QModal
                open={openModal}
                setOpen={setOpenModal}
                headerContent={'Subscription Terms'}
                bodyContent={(
                    <BodyModalSubscriptionTermsComponent />
                )}

            />
            <QModal
                open={openManualToken}
                setOpen={setOpenManualToken}
                headerContent={t("stripe.manualUpdateTitle")}
                bodyContent={(
                    <BodyStripeConnectComponent
                        setOpen={setOpenManualToken}
                        setLoadingFunc={setManualLoading}
                        onSuccess={handleManualStripeSuccess}
                    />
                )}
            />
            <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="auth-page-content overflow-hidden">
                    <div className="container-detail">
                        <div className="overflow-hidden p-5 bdr-10  m-auto">
                            <div className="row g-0">
                                <div className="col-lg-12">
                                    <div>
                                        <div className="d-flex justify-content-center">
                                            <div><a href="#"><img src={webhookEconomicForm} height={150}/></a></div>
                                        </div>
                                        <div>
                                            <div className="mt-5 position-relative text-center">
                                                <h2 className="mb-4 mt-3 fs-23 fw-bold">{t("auth.confirm.title")}</h2>
                                                <p className="cl-bd">
                                                    {t("auth.confirm.connected_as", {
                                                        name: displayName,
                                                        agreement: agreementNumber,
                                                    })}
                                                </p>
                                                <p className="text-muted">{t("auth.confirm.stripe_help")}</p>
                                                <div className="mt-3 d-flex flex-column align-items-center gap-2">
                                                    {ready && liveStep === 1 && stripeUrl ? (
                                                        <a
                                                            href={stripeUrl}
                                                            className="btn bg-orange-zp bdr-10 text-white px-4 py-2"
                                                        >
                                                            {t("auth.confirm.connect_stripe")}
                                                        </a>
                                                    ) : null}
                                                    {ready && liveStep === 1 ? (
                                                        <>
                                                            <p className="text-muted small mb-0">
                                                                {t("auth.confirm.manual_secondary_help")}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-secondary bdr-10"
                                                                disabled={manualLoading}
                                                                onClick={() => setOpenManualToken(true)}
                                                            >
                                                                {t("auth.confirm.enter_token_manually")}
                                                            </button>
                                                        </>
                                                    ) : null}
                                                </div>
                                                <p className="mt-3"><a className={'text-danger'} href={'#'} onClick={(e)=>{e.preventDefault();setOpenModal(true);}}>{t("auth.confirm.terms_link")}</a> {t("auth.confirm.terms_suffix")}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
